import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    redirect: '/home/user',
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('../components/user.vue')
      },
      {
        path: 'image',
        name: 'image',
        component: () => import('../components/image.vue')
      },
      {
        path: 'product',
        name: 'product',
        component: () => import('../components/product.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
